module.exports = __webpack_public_path__ + "media/images/flags/mt-ad168021743f049be24872628bc8305f.png";